import { getRootUrl } from '@shared-config/rootUrl';
import { useTranslation } from 'react-i18next';
import { TooltipStyled } from 'src/components';
import { useCopyToClipboard } from 'src/hooks';

type Props = {
  cartId: string;
};

export const CartId = ({ cartId }: Props) => {
  const { t } = useTranslation();
  const copyToClipboard = useCopyToClipboard();

  return (
    <>
      <TooltipStyled title={t('common.copy_link_to_list')}>
        <span
          className='min-w-[64px] cursor-pointer uppercase transition-all hover:opacity-70'
          onClick={() => copyToClipboard(`${getRootUrl()}/get/${cartId}`)}
        >
          {cartId}
        </span>
      </TooltipStyled>
    </>
  );
};
